import { Textarea } from "../ui";
import { needsReason } from "./access";

export const MIN_REASON = 10;

// Why a published scholarship's set-up changes; null when fine (a draft needs no reason)
export const reasonErrorOf = (scholarship, reason = "") =>
  needsReason(scholarship) && reason.trim().length < MIN_REASON ? `Explain the change in at least ${MIN_REASON} characters` : null;

// The request body with the reason, sent only after publishing
export const withReason = (scholarship, body, reason = "") => (needsReason(scholarship) ? { ...body, reason: reason.trim() } : body);

// The reason a published scholarship's change needs; nothing on a draft
export default function ReasonField({ scholarship, value, onChange, error, disabled }) {
  if (!needsReason(scholarship)) return null;
  return (
    <Textarea
      label="Reason for this change"
      required
      rows={2}
      maxLength={1000}
      placeholder="Why is this changing after publishing?"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={error}
      disabled={disabled}
    />
  );
}
